<template>
  <div>
    <a-card v-if="listEnable" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="16" v-if="enterpriseId == ''">
            <a-col :span="6">
              <a-form-item label="安装类别">
                <a-select v-model="queryParam.installType" allowClear="true">
                  <a-select-option v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange"
                  v-model="queryParam.enterpriseName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data" :title="item.enterpriseName" :key="item.enterpriseId">{{
                    item.enterpriseName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="信息来源名称">
                <a-input v-model="queryParam.sourceName" />
              </a-form-item>
            </a-col>
            <a-col :span="6" style="text-align: right">
              <a-button type="primary" htmlType="submit" style="margin-right: 8px" @click="$refs.table.refresh(true)"
                >查询</a-button
              >
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">清空</a-button>
            </a-col>
          </a-row>
          <a-row :gutter="16" v-if="enterpriseId != ''">
            <a-col :span="6">
              <a-form-item label="安装类别">
                <a-select v-model="queryParam.installType" allowClear="true">
                  <a-select-option v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--<a-col :span="6">-->
            <!--<a-form-item label="企业名称">-->
            <!--<a-select-->
            <!--showSearch-->
            <!--optionFilterProp="children"-->
            <!--@change="handleChange"-->
            <!--v-model="queryParam.enterpriseName"-->
            <!--:filterOption="filterOption"-->
            <!--allowClear="true"-->
            <!--&gt;-->
            <!--<a-select-option v-for="item of data" :title="item.enterpriseName" :key="item.enterpriseId">{{item.enterpriseName}}</a-select-option>-->
            <!--</a-select>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="6">
              <a-form-item label="信息来源名称">
                <a-input v-model="queryParam.sourceName" />
              </a-form-item>
            </a-col>
            <a-col :span="12" style="text-align: right">
              <a-button type="primary" htmlType="submit" style="margin-right: 8px" @click="$refs.table.refresh(true)"
                >查询</a-button
              >
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">清空</a-button>
            </a-col>
          </a-row>
          <a-divider></a-divider>
          <a-row>
            <a-col :span="5" :offset="19" style="text-align: right">
              <a-button
                v-if="addEnable"
                type="primary"
                style="margin-left: 8px"
                icon="plus"
                @click="$refs.modal.add(enterpriseId)"
                >新增</a-button
              >
              <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
              <!--<a-button type="danger" icon="delete" style="width: 120px;" @click="delByIds(selectedRowKeys)">删除</a-button>-->
              <!--</a-dropdown>-->
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        style="margin-top: 20px"
        size="default"
        ref="table"
        rowKey="sourceId"
        :columns="columns"
        :data="loadData"
        bordered
      >
        <span slot="installType" slot-scope="text, record">
          <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">
            {{ type.label }}
          </td>
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="detailEnable" @click="handleShow(record)">查看</a>
          <a-divider v-if="detailEnable" type="vertical" />
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider v-if="removeEnable && editEnabel" type="vertical" />
          <a v-if="removeEnable" @click="delByIds(record.sourceId)">删除</a>
          <span v-if="editEnabel">
            <a-divider type="vertical" />
            <a v-if="record.forbiddenStatus == 1" @click="showState(record.sourceId, record.forbiddenStatus)">启用</a>
            <a v-else @click="showState(record.sourceId, record.forbiddenStatus)">禁用</a>
          </span>
        </span>
      </s-table>
      <source-modal ref="modal" @ok="handleOk" />
    </a-card>
    <no-authority v-if="!listEnable"></no-authority>
  </div>
</template>

<script>
import { STable } from '@/components'
import { getSourceList, delSource, forbiddenSource, enableSource, getSlectCombox } from '@/api/enterprise/source'
import SourceModal from './modules/SourceModal.vue'
import NoAuthority from './NoAuthority'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import store from '@/store'

export default {
  name: 'TableList',
  components: {
    STable,
    SourceModal,
    NoAuthority,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          scopedSlots: { customRender: 'installType' },
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },

        {
          title: '信息来源名称',
          dataIndex: 'sourceName',
          align: 'center',
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getSourceList(Object.assign(parameter, this.queryParam))
      },
      enterpriseId: '',
      data: [],
      restaurantTypes: [],
      listEnable: checkPermission('enterprise:source:list'),
      addEnable: checkPermission('enterprise:source:add'),
      editEnabel: checkPermission('enterprise:source:edit'),
      removeEnable: checkPermission('enterprise:source:remove'),
      detailEnable: checkPermission('enterprise:source:detail'),
    }
  },
  filters: {},
  async created() {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    // console.log(store.getters)
    this.enterpriseId = store.getters.enterpriseId
    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({ code: key, label: value })
    })
    // isAuthority 1   数据隔离
    getSlectCombox({ isAuthority: 1 }).then((res) => {
      // console.log(res.data)
      this.data = res.data
    })
  },

  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(value) {
      // console.log(`selected ${value}`)
      this.queryParam.enterpriseId = value
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    handleShow(record) {
      this.$refs.modal.edit(record, 1)
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleOk(value) {
      // console.log(value)
      if (value == 1) {
        this.$refs.table.refresh(true)
      } else {
        this.$refs.table.refresh()
      }
      // this.$refs.table.refresh(true)
      // console.log('handleSaveOk')
    },
    showState(sourceId, forbiddenStatus) {
      if (forbiddenStatus == 0) {
        forbiddenSource({ sourceId: sourceId }).then((res) => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbiddenStatus == 1) {
        enableSource({ sourceId: sourceId }).then((res) => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    delByIds(sourceId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delSource({ sourceId: sourceId }).then((res) => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
<style scoped>
.ant-divider.ant-divider-horizontal {
  margin: 12px 0 !important;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
/deep/ .ant-table-content {
  width: 40%;
}
</style>
